import React from 'react'

const BugTrackerFormScreen = () => {
  return (
    <div style={{height: "auto"}}><script src="https://static.airtable.com/js/embed/embed_snippet_v1.js"></script><iframe class="airtable-embed airtable-dynamic-height" src="https://airtable.com/embed/shrOCGMJpFjBEAukz?backgroundColor=yellow" style={{}} frameborder="0" onmousewheel="" width="100%" height="2401" ></iframe></div>
  )
}

export default BugTrackerFormScreen